var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonSpeaker2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1588.000000, -504.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Speaker2",
    transform: "translate(1588.000000, 503.999500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6777,6.1943 C12.8227,6.2173 15.1237,9.2003 14.5597,12.2953 L14.5597,12.2953 L13.3867,18.7283 L13.3867,27.9523 C13.3867,30.1883 11.5747,32.0003 9.3397,32.0003 L9.3397,32.0003 L8.0647,32.0003 L8.0647,19.6133 L5.9997,19.6133 L5.9997,6.9783 C7.1027,6.4793 8.3237,6.1943 9.6127,6.1943 L9.6127,6.1943 Z M26,10.0005 L23.087,32.0005 L18,32.0005 L17.16,16.0425 C17.065,14.2455 18.183,12.6065 19.89,12.0375 L19.89,12.0375 L26,10.0005 Z M19.5422,4.0873 C20.1132,4.0293 20.6142,4.3723 20.8172,4.8793 L20.8172,4.8793 L24.0952,5.8603 L23.9002,6.9053 L22.0002,6.5853 L22.0002,9.3343 L21.0002,9.6673 L21.0002,6.4163 L20.4212,6.3183 C20.2422,6.4573 20.0372,6.5653 19.7952,6.5903 C19.1042,6.6603 18.4882,6.1563 18.4172,5.4653 C18.3472,4.7743 18.8512,4.1573 19.5422,4.0873 Z M12.4556,2.30926389e-13 C13.8816,2.30926389e-13 15.0366,1.156 15.0366,2.581 C15.0366,4.007 13.8816,5.163 12.4556,5.163 C11.0306,5.163 9.8756,4.007 9.8756,2.581 C9.8756,1.156 11.0306,2.30926389e-13 12.4556,2.30926389e-13 Z",
    id: 294
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonSpeaker2);
export default __webpack_public_path__ + "static/media/common-speaker-2.67e09f6b.svg";
export { ForwardRef as ReactComponent };